import { composeWithDevTools } from 'redux-devtools-extension'
import { createStore, applyMiddleware } from 'redux'
import { socket } from './core/feathers'
import { configureServices } from './services'
import thunk from 'redux-thunk'
import feathersMiddleware from './feathers-middleware'
import appReducer from './app-reducer'
import { isDev } from './core/env'

const configureStore = initialState => {
  const middleware = applyMiddleware(thunk, feathersMiddleware(socket))
  const store = createStore(
    appReducer,
    initialState,
    isDev() ? composeWithDevTools(middleware) : middleware
  )
  configureServices(store)

  if (process.env.NODE_ENV === 'development') {
    window.dispatch = store.dispatch
    if (module.hot) {
      module.hot.accept('./app-reducer', () => {
        const nextReducer = require('./app-reducer')
        store.replaceReducer(nextReducer)
      })
    }
  }

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/configure-store.js